const IMAGES = {
    face: 'https://cdn.shopify.com/s/files/1/0826/2290/6709/files/FACECHARTFACEFX1.jpg?v=1767998621',
    body: 'https://cdn.shopify.com/s/files/1/0826/2290/6709/files/BODYCHARTFACEFX1.jpg?v=1767998871'
};
const SPLASH_DOTS_PER_POINT = 3;
const SPLASH_SPREAD         = 20;
const RESIZE_DEBOUNCE_MS    = 200;
const ZOOM_MIN = 1.0, ZOOM_MAX = 4.0;
const CROP_ZOOM_MIN = 1.0, CROP_ZOOM_MAX = 3.0;

const STRINGS = {
    es: {
        'mode-face':'Rostro','mode-body':'Cuerpo','upload-label':'Subir Foto',
        'title-pencil':'Lápiz','title-circle':'Círculo','title-splash':'Sangre/Splash',
        'title-text':'Texto','label-size':'Tamaño','label-opacity':'Veladura (Opacidad)',
        's-undo':'Atrás','s-clear':'Reset','s-save':'Descargar Diseño',
        'confirm-change-mode':'Cambiar de plantilla borrará tu diseño actual. ¿Continuar?',
        'confirm-clear':'¿Limpiar todo el diseño?',
        'confirm-upload':'Subir nueva foto borrará tu diseño actual. ¿Continuar?',
        'err-load-template':'No se pudo cargar la plantilla.',
        'err-load-image':'No se pudo cargar la imagen seleccionada.',
        'err-export-cors':'No se puede exportar: usa "Subir Foto" para cargar la plantilla localmente.',
        'err-export-generic':'Error al generar la imagen. Inténtalo de nuevo.',
        'text-input-placeholder':'Escribe y pulsa Enter',
        'placeholder-unavailable':'Plantilla no disponible',
        'placeholder-hint':'Comprueba tu conexión o usa "Subir Foto"',
        'title-eraser':'Borrador','title-pan':'Navegar/Zoom',
        'crop-title':'Ajustar foto','crop-cancel':'Cancelar','crop-apply':'Aplicar',
        'crop-hint':'Arrastra · Pellizca para zoom',
        'settings-theme':'Tema','theme-light':'Claro','theme-dark':'Oscuro',
        'toast-saved':'✓ Diseño guardado',
    },
    en: {
        'mode-face':'Face','mode-body':'Body','upload-label':'Upload Photo',
        'title-pencil':'Pencil','title-circle':'Circle','title-splash':'Blood/Splash',
        'title-text':'Text','label-size':'Size','label-opacity':'Opacity',
        's-undo':'Undo','s-clear':'Reset','s-save':'Download Design',
        'confirm-change-mode':'Changing template will erase your current design. Continue?',
        'confirm-clear':'Clear the entire design?',
        'confirm-upload':'Uploading a new photo will erase your current design. Continue?',
        'err-load-template':'Could not load template.',
        'err-load-image':'Could not load the selected image.',
        'err-export-cors':'Cannot export: use "Upload Photo" to load the template locally.',
        'err-export-generic':'Error generating image. Please try again.',
        'text-input-placeholder':'Type and press Enter',
        'placeholder-unavailable':'Template unavailable',
        'placeholder-hint':'Check your connection or use "Upload Photo"',
        'title-eraser':'Eraser','title-pan':'Navigate/Zoom',
        'crop-title':'Adjust Photo','crop-cancel':'Cancel','crop-apply':'Apply',
        'crop-hint':'Drag · Pinch to zoom',
        'settings-theme':'Theme','theme-light':'Light','theme-dark':'Dark',
        'toast-saved':'✓ Design saved',
    }
};

class StudioApp {
    constructor() {
        this.canvas       = document.getElementById('studio-canvas');
        this.ctx          = this.canvas.getContext('2d');
        this.img          = document.getElementById('studio-img');
        this.wrapper      = document.querySelector('.canvas-container');
        this.inner        = document.querySelector('.canvas-inner');
        this.customUpload = document.getElementById('upload-custom');
        this.lang  = localStorage.getItem('fx-lang')  || 'es';
        this.theme = localStorage.getItem('fx-theme') || 'light';
        this.isDrawing = false; this.tool = 'pencil';
        this.startX = 0; this.startY = 0; this.actions = [];
        this.activeTouchId = null; this.isRenderPending = false; this.cursorPos = null;
        this.canvasZoom = 1; this.canvasPanX = 0; this.canvasPanY = 0; this.panMode = false;
        this.cropState = null; this.cropModalOpen = false; this._dirty = false;
        this.offscreen = document.createElement('canvas');
        this.offscreenCtx = this.offscreen.getContext('2d');
        this.images = IMAGES;
        this.init();
    }
    init() {
        this.resize(); this.bindEvents(); this.setLang(this.lang); this.setTheme(this.theme);
        this._initZoomEvents(); this._initSliderTooltips();
        if (this.img.complete) this.resize(); else this.img.onload = () => this.resize();
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => this.resize(), RESIZE_DEBOUNCE_MS);
        });
    }
    resize() {
        const rect = this.wrapper.getBoundingClientRect();
        const dpr  = window.devicePixelRatio || 1;
        const prevW = parseFloat(this.canvas.style.width)  || 0;
        const prevH = parseFloat(this.canvas.style.height) || 0;
        const newW  = rect.width;
        const newH  = this.img.offsetHeight || (this.img.naturalHeight / this.img.naturalWidth) * rect.width;
        if (prevW > 0 && prevH > 0 && (prevW !== newW || prevH !== newH)) {
            const rx = newW / prevW, ry = newH / prevH;
            this.actions.forEach(a => {
                if (a.t==='pencil'||a.t==='splash') a.pts.forEach(p=>{p.x*=rx;p.y*=ry;});
                if (a.t==='splash') a.splashDots.forEach(d=>{d.x*=rx;d.y*=ry;d.r*=rx;});
                if (a.t==='circle'){a.x*=rx;a.y*=ry;a.r*=rx;}
                if (a.t==='text'){a.x*=rx;a.y*=ry;}
            });
        }
        this.canvas.width=newW*dpr; this.canvas.height=newH*dpr; this.ctx.scale(dpr,dpr);
        this.canvas.style.width=`${newW}px`; this.canvas.style.height=`${newH}px`;
        this.offscreen.width=newW*dpr; this.offscreen.height=newH*dpr; this.offscreenCtx.scale(dpr,dpr);
        this._rebuildOffscreen(); this.render();
    }
    bindEvents() {
        document.querySelectorAll('.btn-tool:not(#btn-pan-mode)').forEach(btn => {
            btn.addEventListener('click', e => this.setTool(e.currentTarget.id.replace('btn-','')));
        });
        const btnS = document.getElementById('btn-settings');
        const panel = document.getElementById('settings-panel');
        const closePanel = () => { panel.setAttribute('hidden',''); btnS.classList.remove('active'); };
        btnS.addEventListener('click', e => {
            e.stopPropagation();
            if (panel.hasAttribute('hidden')) { panel.removeAttribute('hidden'); btnS.classList.add('active'); }
            else closePanel();
        });
        document.addEventListener('click', e => {
            if (!panel.hasAttribute('hidden') && !panel.contains(e.target) && !btnS.contains(e.target)) closePanel();
        });
        document.querySelectorAll('.btn-lang-opt').forEach(b => b.addEventListener('click',()=>{this.setLang(b.dataset.lang);closePanel();}));
        document.querySelectorAll('.btn-theme-opt').forEach(b => b.addEventListener('click',()=>{this.setTheme(b.dataset.theme);closePanel();}));
        document.getElementById('mode-face').onclick = () => this.setMode('face');
        document.getElementById('mode-body').onclick = () => this.setMode('body');
        document.getElementById('s-undo').onclick = () => {
            this.actions.pop(); if(!this.actions.length) this._dirty=false;
            this._rebuildOffscreen(); this.render();
        };
        document.getElementById('s-clear').onclick = () => {
            if(confirm(this._t('confirm-clear'))) {
                this.actions=[]; this._dirty=false;
                this.offscreenCtx.clearRect(0,0,this.offscreen.width,this.offscreen.height);
                this.render();
            }
        };
        document.getElementById('s-save').onclick = () => this.save();
        document.getElementById('s-size').addEventListener('input', e => {
            const el=document.getElementById('val-size'); if(el) el.textContent=e.target.value;
            if(this.tool==='eraser') this._updateEraserCursor();
        });
        document.getElementById('s-opacity').addEventListener('input', e => {
            const el=document.getElementById('val-opacity');
            if(el) el.textContent=Math.round(parseFloat(e.target.value)*100)+'%';
        });
        this.customUpload.addEventListener('change', e => this.handleUpload(e));
        this.canvas.addEventListener('mousedown', e => this.start(e));
        window.addEventListener('mousemove', e => this.move(e));
        window.addEventListener('mouseup', () => this.stop());
        this.canvas.addEventListener('mousemove', e => {
            this.cursorPos = this.getPos(e);
            if(!this.isRenderPending){this.isRenderPending=true;requestAnimationFrame(()=>this.render());}
        });
        this.canvas.addEventListener('mouseleave', () => { this.cursorPos=null; this.render(); });
        this.canvas.addEventListener('touchstart', e => this.touchStart(e), {passive:false});
        window.addEventListener('touchmove', e => this.touchMove(e), {passive:false});
        window.addEventListener('touchend', e => this.touchEnd(e));
        window.addEventListener('touchcancel', e => this.touchEnd(e));
        this._bindCropEvents();
    }
    setTool(t) {
        this.tool=t;
        if(this.panMode){
            this.panMode=false;
            const pb=document.getElementById('btn-pan-mode');if(pb)pb.classList.remove('active');
            if(this.wrapper)this.wrapper.style.cursor='';
        }
        if(t==='text'){
            const s=document.getElementById('s-size'),v=document.getElementById('val-size');
            if(parseFloat(s.value)<20){s.value='24';if(v)v.textContent='24';}
            this.canvas.style.cursor='text';
        } else if(t==='eraser'){this._updateEraserCursor();}
        else{this.canvas.style.cursor='none';}
        document.querySelectorAll('.btn-tool').forEach(b=>b.classList.remove('active'));
        const btn=document.getElementById(`btn-${t}`); if(btn) btn.classList.add('active');
    }
    setMode(mode) {
        if(this.actions.length>0&&!confirm(this._t('confirm-change-mode'))) return;
        this.actions=[]; this._dirty=false; this.wrapper.classList.add('img-loading');
        const onLoaded=()=>{this.wrapper.classList.remove('img-loading');this.img.onload=null;this.img.onerror=null;this.resize();};
        this.img.onerror=()=>{this._showError(this._t('err-load-template'));this.img.removeAttribute('crossorigin');this.img.src=this._makePlaceholder();onLoaded();};
        this.img.onload=onLoaded; this.img.crossOrigin='anonymous'; this.img.src=this.images[mode];
        document.querySelectorAll('.btn-mode').forEach(b=>{b.classList.remove('active');b.setAttribute('aria-pressed','false');});
        const ab=document.getElementById(`mode-${mode}`); ab.classList.add('active'); ab.setAttribute('aria-pressed','true');
    }
    handleUpload(e) {
        const file=e.target.files[0]; if(!file) return;
        const reader=new FileReader();
        reader.onload=ev=>{
            const tmp=new Image();
            tmp.onload=()=>this._openCropModal(tmp,this.img.naturalWidth||800,this.img.naturalHeight||1066);
            tmp.onerror=()=>this._showError(this._t('err-load-image'));
            tmp.src=ev.target.result;
        };
        reader.readAsDataURL(file);
    }
    getPos(e) {
        const rect=this.wrapper.getBoundingClientRect();
        const cx=e.clientX!==undefined?e.clientX:e.touches[0].clientX;
        const cy=e.clientY!==undefined?e.clientY:e.touches[0].clientY;
        return{x:(cx-rect.left-this.canvasPanX)/this.canvasZoom,y:(cy-rect.top-this.canvasPanY)/this.canvasZoom};
    }
    start(e) {
        if(e.target!==this.canvas||this.panMode) return;
        if(e.preventDefault) e.preventDefault();
        const p=this.getPos(e);
        if(this.tool==='text'){this._showTextInput(p);return;}
        this.isDrawing=true; this._dirty=true; this.startX=p.x; this.startY=p.y;
        this.actions.push({t:this.tool,c:document.getElementById('s-color').value,
            s:parseFloat(document.getElementById('s-size').value),
            o:parseFloat(document.getElementById('s-opacity').value),
            x:p.x,y:p.y,r:0,pts:[p],splashDots:[]});
    }
    move(e) {
        if(!this.isDrawing) return;
        if(e.cancelable) e.preventDefault();
        const p=this.getPos(e); const cur=this.actions[this.actions.length-1];
        if(this.tool==='circle'){cur.r=Math.sqrt(Math.pow(p.x-this.startX,2)+Math.pow(p.y-this.startY,2));}
        else if(this.tool==='splash'){
            cur.pts.push(p);
            for(let i=0;i<SPLASH_DOTS_PER_POINT;i++)
                cur.splashDots.push({x:p.x+(Math.random()-.5)*SPLASH_SPREAD,y:p.y+(Math.random()-.5)*SPLASH_SPREAD,r:Math.random()*cur.s/2.5});
        } else cur.pts.push(p);
        if(!this.isRenderPending){this.isRenderPending=true;requestAnimationFrame(()=>this.render());}
    }
    stop(){if(!this.isDrawing)return;this.isDrawing=false;this._commitLastAction();this.render();}
    touchStart(e){
        if(this.cropModalOpen||e.target!==this.canvas&&e.target!==this.img)return;
        e.preventDefault();
        if(this.activeTouchId!==null||this.panMode)return;
        e.stopPropagation(); // solo al dibujar
        const t=e.changedTouches[0]; this.activeTouchId=t.identifier;
        this.start({clientX:t.clientX,clientY:t.clientY,target:this.canvas});
    }
    touchMove(e){
        if(this.cropModalOpen||this.activeTouchId===null)return;
        if(e.cancelable){e.preventDefault();e.stopPropagation();}
        const t=Array.from(e.changedTouches).find(t=>t.identifier===this.activeTouchId);
        if(t) this.move({clientX:t.clientX,clientY:t.clientY});
    }
    touchEnd(e){
        if(this.cropModalOpen||this.activeTouchId===null)return;
        const t=Array.from(e.changedTouches).find(t=>t.identifier===this.activeTouchId);
        if(!t)return; this.activeTouchId=null; this.stop();
    }
    render(){
        this.isRenderPending=false;
        const dpr=window.devicePixelRatio||1;
        const lw=this.canvas.width/dpr, lh=this.canvas.height/dpr;
        this.ctx.clearRect(0,0,lw,lh);
        if(this.offscreen.width>0) this.ctx.drawImage(this.offscreen,0,0,lw,lh);
        if(this.isDrawing&&this.actions.length>0) this._drawAction(this.ctx,this.actions[this.actions.length-1]);
        if(this.cursorPos&&!this.activeTouchId&&this.tool!=='text'&&this.tool!=='eraser'){
            const sz=parseFloat(document.getElementById('s-size').value);
            const col=document.getElementById('s-color').value;
            const r=Math.max(sz/2,1);
            this.ctx.save();
            this.ctx.strokeStyle=col;this.ctx.lineWidth=1;this.ctx.globalAlpha=0.85;
            this.ctx.beginPath();this.ctx.arc(this.cursorPos.x,this.cursorPos.y,r,0,Math.PI*2);this.ctx.stroke();
            this.ctx.fillStyle=col;this.ctx.globalAlpha=0.6;
            this.ctx.beginPath();this.ctx.arc(this.cursorPos.x,this.cursorPos.y,1.5,0,Math.PI*2);this.ctx.fill();
            this.ctx.restore();
        }
    }
    save(){this.exportAs('png',1.0);}
    exportAs(format='png',quality=1.0){
        const w=this.img.naturalWidth,h=this.img.naturalHeight;
        const scale=w/this.wrapper.getBoundingClientRect().width;
        const ac=document.createElement('canvas'); ac.width=w; ac.height=h;
        const aCtx=ac.getContext('2d');
        this.actions.forEach(a=>{
            aCtx.save(); aCtx.lineWidth=a.s*scale; aCtx.lineCap=aCtx.lineJoin='round';
            if(a.t==='eraser'){
                aCtx.globalCompositeOperation='destination-out'; aCtx.globalAlpha=1;
                aCtx.beginPath();
                if(a.pts.length>0){aCtx.moveTo(a.pts[0].x*scale,a.pts[0].y*scale);a.pts.forEach(p=>aCtx.lineTo(p.x*scale,p.y*scale));}
                aCtx.stroke();
            } else {
                aCtx.globalAlpha=a.o; aCtx.strokeStyle=aCtx.fillStyle=a.c;
                if(a.t==='pencil'){
                    aCtx.beginPath();
                    if(a.pts.length>0){aCtx.moveTo(a.pts[0].x*scale,a.pts[0].y*scale);a.pts.forEach(p=>aCtx.lineTo(p.x*scale,p.y*scale));}
                    aCtx.stroke();
                } else if(a.t==='circle'){aCtx.beginPath();aCtx.arc(a.x*scale,a.y*scale,a.r*scale,0,Math.PI*2);aCtx.stroke();}
                else if(a.t==='splash'){a.splashDots.forEach(d=>{aCtx.beginPath();aCtx.arc(d.x*scale,d.y*scale,d.r*scale,0,Math.PI*2);aCtx.fill();});}
                else if(a.t==='text'){aCtx.font=`bold ${a.s*scale}px 'Barlow Condensed',sans-serif`;aCtx.fillText(a.val,a.x*scale,a.y*scale);}
            }
            aCtx.restore();
        });
        const tc=document.createElement('canvas'); tc.width=w; tc.height=h;
        const tCtx=tc.getContext('2d'); tCtx.drawImage(this.img,0,0); tCtx.drawImage(ac,0,0);
        const mime=format==='jpeg'?'image/jpeg':'image/png';
        let dataURL;
        try{dataURL=tc.toDataURL(mime,quality);}
        catch(err){this._showError(err.name==='SecurityError'?this._t('err-export-cors'):this._t('err-export-generic'));return;}
        const ts=new Date().toISOString().replace(/[-:T]/g,'').slice(0,15);
        const filename=`StudioCHART-${ts}.${format==='jpeg'?'jpg':'png'}`;
        const blob=this._dataURLtoBlob(dataURL,mime);
        const file=new File([blob],filename,{type:mime});
        if(navigator.canShare&&navigator.canShare({files:[file]})){
            navigator.share({files:[file],title:'Mi diseño StudioCHART'})
                .then(()=>{this._dirty=false;this.showToast(this._t('toast-saved'));})
                .catch(e=>{if(e.name==='AbortError')return;this._downloadDataURL(dataURL,filename);});
        } else {this._downloadDataURL(dataURL,filename);}
    }
    _dataURLtoBlob(dataURL,mimeType){
        const b=atob(dataURL.split(',')[1]),arr=new Uint8Array(b.length);
        for(let i=0;i<b.length;i++)arr[i]=b.charCodeAt(i);
        return new Blob([arr],{type:mimeType});
    }
    _downloadDataURL(dataURL,filename){
        const a=document.createElement('a'); a.download=filename; a.href=dataURL; a.click();
        this._dirty=false; this.showToast(this._t('toast-saved'));
    }
    showToast(text){
        document.getElementById('fx-toast')?.remove();
        const t=document.createElement('div'); t.id='fx-toast'; t.className='fx-toast'; t.textContent=text;
        document.body.appendChild(t);
        requestAnimationFrame(()=>requestAnimationFrame(()=>t.classList.add('fx-toast--visible')));
        setTimeout(()=>{t.classList.remove('fx-toast--visible');t.addEventListener('transitionend',()=>t.remove(),{once:true});},2000);
    }
    setLang(lang){
        this.lang=lang; localStorage.setItem('fx-lang',lang);
        document.getElementById('html-root').lang=lang;
        document.querySelectorAll('[data-i18n]').forEach(el=>{const k=el.dataset.i18n;if(STRINGS[lang][k]!==undefined)el.textContent=STRINGS[lang][k];});
        document.querySelectorAll('[data-i18n-title]').forEach(el=>{const k=el.dataset.i18nTitle;if(STRINGS[lang][k]!==undefined)el.title=STRINGS[lang][k];});
        document.querySelectorAll('.btn-lang-opt').forEach(b=>b.classList.toggle('active',b.dataset.lang===lang));
    }
    setTheme(theme){
        this.theme=theme; localStorage.setItem('fx-theme',theme);
        document.getElementById('html-root').setAttribute('data-theme',theme);
        document.querySelectorAll('.btn-theme-opt').forEach(b=>b.classList.toggle('active',b.dataset.theme===theme));
    }
    _t(key){return(STRINGS[this.lang]||STRINGS.es)[key]||key;}
    _drawAction(ctx,a){
        ctx.save(); ctx.globalAlpha=a.t==='eraser'?1:a.o; ctx.strokeStyle=ctx.fillStyle=a.c;
        ctx.lineWidth=a.s; ctx.lineCap=ctx.lineJoin='round';
        if(a.t==='eraser'){ctx.globalCompositeOperation='destination-out';ctx.beginPath();if(a.pts.length>0){ctx.moveTo(a.pts[0].x,a.pts[0].y);a.pts.forEach(p=>ctx.lineTo(p.x,p.y));}ctx.stroke();}
        else if(a.t==='pencil'){ctx.beginPath();if(a.pts.length>0){ctx.moveTo(a.pts[0].x,a.pts[0].y);a.pts.forEach(p=>ctx.lineTo(p.x,p.y));}ctx.stroke();}
        else if(a.t==='circle'){ctx.beginPath();ctx.arc(a.x,a.y,a.r,0,Math.PI*2);ctx.stroke();}
        else if(a.t==='splash'){a.splashDots.forEach(d=>{ctx.beginPath();ctx.arc(d.x,d.y,d.r,0,Math.PI*2);ctx.fill();});}
        else if(a.t==='text'){ctx.font=`bold ${a.s}px 'Barlow Condensed',sans-serif`;ctx.fillText(a.val,a.x,a.y);}
        ctx.restore();
    }
    _commitLastAction(){if(this.actions.length===0)return;this._drawAction(this.offscreenCtx,this.actions[this.actions.length-1]);}
    _rebuildOffscreen(){this.offscreenCtx.clearRect(0,0,this.offscreen.width,this.offscreen.height);this.actions.forEach(a=>this._drawAction(this.offscreenCtx,a));}
    _initSliderTooltips(){
        [{id:'s-size',fmt:v=>v},{id:'s-opacity',fmt:v=>Math.round(parseFloat(v)*100)+'%'}].forEach(({id,fmt})=>{
            const input=document.getElementById(id); if(!input)return;
            const tip=document.createElement('div'); tip.className='slider-tooltip';
            const grp=input.closest('.slider-group'); if(!grp)return; grp.appendChild(tip);
            const upd=()=>{const mn=parseFloat(input.min)||0,mx=parseFloat(input.max)||100,val=parseFloat(input.value),pct=(val-mn)/(mx-mn),tw=12,trk=input.offsetWidth-tw;tip.style.left=`${tw/2+pct*trk}px`;tip.textContent=fmt(input.value);};
            const show=()=>{upd();tip.classList.add('visible');};
            const hide=()=>tip.classList.remove('visible');
            input.addEventListener('mousedown',show);input.addEventListener('touchstart',show,{passive:true});
            input.addEventListener('input',()=>{if(tip.classList.contains('visible'))upd();});
            input.addEventListener('mouseup',hide);input.addEventListener('touchend',()=>setTimeout(hide,500));
        });
    }
    _applyCanvasTransform(tr=false){
        if(tr){this.inner.style.transition='transform 0.3s ease';this.inner.addEventListener('transitionend',()=>{this.inner.style.transition='';},{once:true});}
        this.inner.style.transform=`translate(${this.canvasPanX}px,${this.canvasPanY}px) scale(${this.canvasZoom})`;
        const b=document.getElementById('btn-reset-zoom');if(b)b.hidden=this.canvasZoom<=1.005;
    }
    _clampCanvasPan(){
        const wr=this.wrapper.getBoundingClientRect();
        const iW=wr.width*this.canvasZoom,iH=(this.inner.offsetHeight||wr.width)*this.canvasZoom;
        this.canvasPanX=Math.max(Math.min(0,wr.width-iW),Math.min(0,this.canvasPanX));
        this.canvasPanY=Math.max(Math.min(0,wr.height-iH),Math.min(0,this.canvasPanY));
    }
    _resetZoom(){this.canvasZoom=1;this.canvasPanX=0;this.canvasPanY=0;this._applyCanvasTransform(true);}
    _initZoomEvents(){
        const wr=this.wrapper;
        document.getElementById('btn-reset-zoom').addEventListener('click',()=>this._resetZoom());
        document.getElementById('btn-pan-mode').addEventListener('click',()=>{
            this.panMode=!this.panMode;
            const b=document.getElementById('btn-pan-mode');b.classList.toggle('active',this.panMode);
            if(this.panMode){wr.style.cursor='grab';this.canvas.style.cursor='grab';}
            else{wr.style.cursor='';this.setTool(this.tool);}
        });
        wr.addEventListener('wheel',e=>{
            if(this.cropModalOpen||!this.panMode)return; e.preventDefault();
            const r=wr.getBoundingClientRect(),ox=e.clientX-r.left,oy=e.clientY-r.top;
            const d=-e.deltaY*0.001,oz=this.canvasZoom,nz=Math.max(ZOOM_MIN,Math.min(ZOOM_MAX,oz+d*oz));
            this.canvasPanX=ox-(ox-this.canvasPanX)*(nz/oz);this.canvasPanY=oy-(oy-this.canvasPanY)*(nz/oz);
            this.canvasZoom=nz;this._clampCanvasPan();this._applyCanvasTransform();
        },{passive:false});
        let pinch=null,panTouch=null;
        wr.addEventListener('touchstart',e=>{
            if(this.cropModalOpen||!this.panMode)return;
            if(e.touches.length===2){const t1=e.touches[0],t2=e.touches[1],r=wr.getBoundingClientRect();
                pinch={dist:Math.hypot(t1.clientX-t2.clientX,t1.clientY-t2.clientY),zoom:this.canvasZoom,panX:this.canvasPanX,panY:this.canvasPanY,midX:(t1.clientX+t2.clientX)/2-r.left,midY:(t1.clientY+t2.clientY)/2-r.top};
                e.preventDefault();return;}
            if(e.touches.length===1){const t=e.touches[0];panTouch={id:t.identifier,startX:t.clientX,startY:t.clientY,startPanX:this.canvasPanX,startPanY:this.canvasPanY};e.preventDefault();}
        },{passive:false});
        window.addEventListener('touchmove',e=>{
            if(this.cropModalOpen||!this.panMode)return;
            if(pinch&&e.touches.length>=2){if(e.cancelable)e.preventDefault();
                const t1=e.touches[0],t2=e.touches[1],dist=Math.hypot(t1.clientX-t2.clientX,t1.clientY-t2.clientY);
                const nz=Math.max(ZOOM_MIN,Math.min(ZOOM_MAX,pinch.zoom*dist/pinch.dist));
                this.canvasPanX=pinch.midX-(pinch.midX-pinch.panX)*(nz/pinch.zoom);
                this.canvasPanY=pinch.midY-(pinch.midY-pinch.panY)*(nz/pinch.zoom);
                this.canvasZoom=nz;this._clampCanvasPan();this._applyCanvasTransform();return;}
            if(panTouch&&e.touches.length===1){const t=Array.from(e.touches).find(t=>t.identifier===panTouch.id);
                if(!t)return;if(e.cancelable)e.preventDefault();
                this.canvasPanX=panTouch.startPanX+(t.clientX-panTouch.startX);
                this.canvasPanY=panTouch.startPanY+(t.clientY-panTouch.startY);
                this._clampCanvasPan();this._applyCanvasTransform();}
        },{passive:false});
        window.addEventListener('touchend',e=>{if(e.touches.length<2)pinch=null;if(e.touches.length===0)panTouch=null;});
        let mp=null;
        wr.addEventListener('mousedown',e=>{
            if(this.cropModalOpen||!this.panMode||e.button!==0)return;
            mp={startX:e.clientX,startY:e.clientY,startPanX:this.canvasPanX,startPanY:this.canvasPanY};
            wr.style.cursor='grabbing';this.canvas.style.cursor='grabbing';e.preventDefault();
        });
        window.addEventListener('mousemove',e=>{
            if(!mp)return;
            this.canvasPanX=mp.startPanX+(e.clientX-mp.startX);this.canvasPanY=mp.startPanY+(e.clientY-mp.startY);
            this._clampCanvasPan();this._applyCanvasTransform();
        });
        window.addEventListener('mouseup',()=>{
            if(mp){mp=null;wr.style.cursor=this.panMode?'grab':'';this.canvas.style.cursor=this.panMode?'grab':'';if(!this.panMode)this.setTool(this.tool);}
        });
    }
    _updateEraserCursor(){
        const s=parseFloat(document.getElementById('s-size').value),r=Math.max(s/2,4),pad=4,d=Math.round(r*2+pad*2),cx=d/2;
        const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${d}" height="${d}"><circle cx="${cx}" cy="${cx}" r="${r}" fill="none" stroke="#000" stroke-width="3"/><circle cx="${cx}" cy="${cx}" r="${r}" fill="none" stroke="#fff" stroke-width="1.5"/></svg>`;
        this.canvas.style.cursor=`url("data:image/svg+xml,${encodeURIComponent(svg)}") ${cx} ${cx},crosshair`;
    }
    _openCropModal(img,dstW,dstH){
        const modal=document.getElementById('crop-modal'),prev=document.getElementById('crop-preview-img');
        prev.style.width=img.naturalWidth+'px';prev.style.height=img.naturalHeight+'px';prev.src=img.src;
        document.getElementById('crop-zoom-slider').value=100;modal.removeAttribute('hidden');this.cropModalOpen=true;
        requestAnimationFrame(()=>{
            const wrap=document.querySelector('.crop-viewport-wrap'),wr=wrap.getBoundingClientRect(),ratio=dstW/dstH;
            const aW=wr.width-32,aH=wr.height-32;let vpW,vpH;
            if(aW/aH>ratio){vpH=Math.max(aH,100);vpW=vpH*ratio;}else{vpW=Math.max(aW,80);vpH=vpW/ratio;}
            const vp=document.getElementById('crop-viewport');vp.style.width=vpW+'px';vp.style.height=vpH+'px';
            const bs=Math.max(vpW/img.naturalWidth,vpH/img.naturalHeight);
            this.cropState={img,panX:0,panY:0,zoom:1,baseScale:bs,vpW,vpH,dstW,dstH};this._renderCropPreview();
        });
    }
    _closeCropModal(){document.getElementById('crop-modal').setAttribute('hidden','');document.getElementById('crop-preview-img').src='';this.cropState=null;this.cropModalOpen=false;this.customUpload.value='';}
    _renderCropPreview(){if(!this.cropState)return;const{panX,panY,baseScale,zoom}=this.cropState;const ds=baseScale*zoom;document.getElementById('crop-preview-img').style.transform=`translate(calc(-50% + ${panX}px),calc(-50% + ${panY}px)) scale(${ds})`;}
    _clampCropPan(){if(!this.cropState)return;const{vpW,vpH,img,baseScale,zoom}=this.cropState,ds=baseScale*zoom;const mx=Math.max(0,(img.naturalWidth*ds-vpW)/2),my=Math.max(0,(img.naturalHeight*ds-vpH)/2);this.cropState.panX=Math.max(-mx,Math.min(mx,this.cropState.panX));this.cropState.panY=Math.max(-my,Math.min(my,this.cropState.panY));}
    _applyCrop(){
        if(!this.cropState)return;if(this.actions.length>0&&!confirm(this._t('confirm-upload')))return;
        const{img,panX,panY,baseScale,zoom,vpW,vpH,dstW,dstH}=this.cropState,ds=baseScale*zoom;
        const cW=vpW/ds,cH=vpH/ds,cX=img.naturalWidth/2-vpW/(2*ds)-panX/ds,cY=img.naturalHeight/2-vpH/(2*ds)-panY/ds;
        const sX=Math.max(0,Math.min(img.naturalWidth-cW,cX)),sY=Math.max(0,Math.min(img.naturalHeight-cH,cY));
        const tmp=document.createElement('canvas');tmp.width=dstW;tmp.height=dstH;
        tmp.getContext('2d').drawImage(img,sX,sY,cW,cH,0,0,dstW,dstH);
        this.actions=[];this.img.removeAttribute('crossorigin');this.img.src=tmp.toDataURL('image/jpeg',0.92);
        document.querySelectorAll('.btn-mode').forEach(b=>b.classList.remove('active'));this._closeCropModal();
    }
    _bindCropEvents(){
        document.getElementById('crop-cancel').addEventListener('click',()=>this._closeCropModal());
        document.getElementById('crop-apply').addEventListener('click',()=>this._applyCrop());
        document.getElementById('crop-zoom-slider').addEventListener('input',e=>{if(!this.cropState)return;this.cropState.zoom=parseInt(e.target.value)/100;this._clampCropPan();this._renderCropPreview();});
        const vp=document.getElementById('crop-viewport');
        let mD=false,mSX,mSY,mSPX,mSPY;
        vp.addEventListener('mousedown',e=>{if(!this.cropState)return;mD=true;mSX=e.clientX;mSY=e.clientY;mSPX=this.cropState.panX;mSPY=this.cropState.panY;e.preventDefault();});
        window.addEventListener('mousemove',e=>{if(!mD||!this.cropState)return;this.cropState.panX=mSPX+(e.clientX-mSX);this.cropState.panY=mSPY+(e.clientY-mSY);this._clampCropPan();this._renderCropPreview();});
        window.addEventListener('mouseup',()=>{mD=false;});
        vp.addEventListener('wheel',e=>{
            if(!this.cropState)return;e.preventDefault();
            const r=vp.getBoundingClientRect(),{vpW,vpH,baseScale}=this.cropState;
            const oz=this.cropState.zoom,nz=Math.max(CROP_ZOOM_MIN,Math.min(CROP_ZOOM_MAX,oz-e.deltaY*0.001));
            const od=baseScale*oz,nd=baseScale*nz,mx=e.clientX-r.left,my=e.clientY-r.top;
            this.cropState.panX=mx-vpW/2-(mx-vpW/2-this.cropState.panX)*(nd/od);
            this.cropState.panY=my-vpH/2-(my-vpH/2-this.cropState.panY)*(nd/od);
            this.cropState.zoom=nz;document.getElementById('crop-zoom-slider').value=Math.round(nz*100);
            this._clampCropPan();this._renderCropPreview();
        },{passive:false});
        const ct=new Map();let ps=null,pnS=null;
        vp.addEventListener('touchstart',e=>{
            if(!this.cropState)return;e.preventDefault();
            Array.from(e.changedTouches).forEach(t=>ct.set(t.identifier,t));
            if(ct.size===1){const[t]=ct.values();pnS={touchId:t.identifier,startClientX:t.clientX,startClientY:t.clientY,startPanX:this.cropState.panX,startPanY:this.cropState.panY};ps=null;}
            else if(ct.size===2){const[t1,t2]=ct.values(),r=vp.getBoundingClientRect();ps={startDist:Math.hypot(t1.clientX-t2.clientX,t1.clientY-t2.clientY),startZoom:this.cropState.zoom,startPanX:this.cropState.panX,startPanY:this.cropState.panY,midVpX:(t1.clientX+t2.clientX)/2-r.left,midVpY:(t1.clientY+t2.clientY)/2-r.top};pnS=null;}
        },{passive:false});
        window.addEventListener('touchmove',e=>{
            if(!this.cropModalOpen||!this.cropState)return;if(e.cancelable)e.preventDefault();
            Array.from(e.changedTouches).forEach(t=>ct.set(t.identifier,t));
            if(ct.size===1&&pnS){const t=ct.get(pnS.touchId);if(!t)return;this.cropState.panX=pnS.startPanX+(t.clientX-pnS.startClientX);this.cropState.panY=pnS.startPanY+(t.clientY-pnS.startClientY);this._clampCropPan();this._renderCropPreview();}
            else if(ct.size===2&&ps){const[t1,t2]=ct.values(),dist=Math.hypot(t1.clientX-t2.clientX,t1.clientY-t2.clientY),nz=Math.max(CROP_ZOOM_MIN,Math.min(CROP_ZOOM_MAX,ps.startZoom*dist/ps.startDist));const{vpW,vpH,baseScale}=this.cropState,od=baseScale*ps.startZoom,nd=baseScale*nz,{midVpX,midVpY}=ps;this.cropState.panX=midVpX-vpW/2-(midVpX-vpW/2-ps.startPanX)*(nd/od);this.cropState.panY=midVpY-vpH/2-(midVpY-vpH/2-ps.startPanY)*(nd/od);this.cropState.zoom=nz;document.getElementById('crop-zoom-slider').value=Math.round(nz*100);this._clampCropPan();this._renderCropPreview();}
        },{passive:false});
        const onTE=e=>{if(!this.cropModalOpen)return;Array.from(e.changedTouches).forEach(t=>ct.delete(t.identifier));if(ct.size<2)ps=null;if(ct.size===0){pnS=null;return;}if(ct.size===1&&!pnS&&this.cropState){const[t]=ct.values();pnS={touchId:t.identifier,startClientX:t.clientX,startClientY:t.clientY,startPanX:this.cropState.panX,startPanY:this.cropState.panY};}};
        window.addEventListener('touchend',onTE);window.addEventListener('touchcancel',onTE);
    }
    _showTextInput(p){
        const cr=this.canvas.getBoundingClientRect(),sz=Math.max(parseFloat(document.getElementById('s-size').value),16);
        const inp=document.createElement('input');inp.type='text';inp.placeholder=this._t('text-input-placeholder');
        Object.assign(inp.style,{position:'absolute',left:`${p.x}px`,top:`${p.y}px`,transform:'translateY(-50%)',minWidth:'140px',maxWidth:`${cr.width-p.x-8}px`,fontSize:`${sz}px`,fontFamily:'Inter,sans-serif',fontWeight:'bold',color:document.getElementById('s-color').value,background:'rgba(255,255,255,0.92)',border:'2px solid #e60000',borderRadius:'4px',padding:'4px 8px',outline:'none',zIndex:'100',boxShadow:'0 2px 8px rgba(0,0,0,0.15)'});
        this.wrapper.appendChild(inp);inp.focus();
        const done=()=>{const txt=inp.value.trim();inp.remove();if(!txt)return;this._dirty=true;this.actions.push({t:'text',val:txt,x:p.x,y:p.y,s:parseFloat(document.getElementById('s-size').value),c:document.getElementById('s-color').value,o:parseFloat(document.getElementById('s-opacity').value)});this._commitLastAction();this.render();};
        inp.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();done();}if(e.key==='Escape')inp.remove();});
        inp.addEventListener('blur',done);
    }
    _makePlaceholder(){
        const c=document.createElement('canvas');c.width=600;c.height=800;const ctx=c.getContext('2d');
        ctx.fillStyle='#f0f0f0';ctx.fillRect(0,0,600,800);ctx.strokeStyle='#cccccc';ctx.lineWidth=2;ctx.strokeRect(10,10,580,780);
        ctx.fillStyle='#999';ctx.font='bold 22px sans-serif';ctx.textAlign='center';ctx.fillText(this._t('placeholder-unavailable'),300,380);
        ctx.font='15px sans-serif';ctx.fillText(this._t('placeholder-hint'),300,414);return c.toDataURL();
    }
    _showError(msg){
        document.getElementById('fx-toast')?.remove();const t=document.createElement('div');t.id='fx-toast';t.className='fx-toast fx-toast--error';t.textContent=msg;document.body.appendChild(t);
        requestAnimationFrame(()=>requestAnimationFrame(()=>t.classList.add('fx-toast--visible')));
        setTimeout(()=>{t.classList.remove('fx-toast--visible');t.addEventListener('transitionend',()=>t.remove(),{once:true});},5000);
    }
}

new StudioApp();
